module.exports = __webpack_public_path__ + "static/media/arrowLeftTwo.4990ee13.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/arrowLeftTwo.png
// module id = 1731
// module chunks = 0 1